import React from "react";
import "./styles.css"
import "./priceDifferences.css"
import * as axios from "axios";
import {TextField, MenuItem, IconButton, Popover, Button, Switch, FormControlLabel} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import LastPageIcon from "@material-ui/icons/LastPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import OrderDetailsModal from "../../Components/OrderDetailsModal";
import PriceDifferences from "./PriceDifferences";

// Must match the backend's ListAllOrdersPaginated page size (see
// FindAllOrdersLimitPaginated's `limit` argument).
const ORDERS_PAGE_SIZE = 30;

export default class Orders extends React.Component {

  state = {
    orders: [],
    loading: false,
    page: 0,
    maxPage: 100,
    canPreviousPage: false,
    canNextPage: true,
    selectedOrder: null,
    finalizeHourAnchor: null,
    finalizeHourOrder: null,
    finalizeHourValue: '',
    userId: null,
    priceDifferencesOpen: false,
    // Super admins: "Toate comenzile" also lists deleted orders.
    showDeleted: false,
  };

  componentDidMount() {
    const userId = new URLSearchParams(this.props.location.search).get('userId');
    this.setState({userId: userId || null});
    this.getOrders(0, userId || null);
    this.setState({
      darkMode: localStorage.getItem('darkMode') === 'true'
    })
  }

  clearUserFilter = () => {
    this.props.history.push('/orders');
    this.setState({userId: null});
    this.getOrders(0, null);
  }

  translateStatus = (status) => {
    switch (status) {
      case 'created':
        return 'Creată';
      case 'accepted':
        return 'Acceptată';
      case 'prepared':
        return 'Preparată';
      case 'picked':
        return 'Ridicată';
      case 'delivered':
        return 'Livrată';
      case 'canceled':
        return 'Anulată';
      default:
        return 'STATUS INVALID!!!'
    }
  }

  getOrders = async (page, userId) => {
    this.setState({loading: true});
    // const baseUrl = 'http://localhost:8080/';
    const baseUrl = 'https://api.appetito.ro/';
    const token = localStorage.getItem('access_token');
    const response = await axios.default.get(`${baseUrl}v1/admin/orders/${page}`, {
      params: {...(userId ? {userId} : {}), ...(this.state.showDeleted ? {all: 1} : {})},
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    // response.data is either the new {orders, total_count} shape, or (until
    // the backend carrying that change is deployed) the old plain array —
    // fall back to the static 100-page guess in that case.
    const isPaged = !Array.isArray(response.data);
    const orders = isPaged ? response.data.orders : response.data;
    const maxPage = isPaged ? Math.max(1, Math.ceil(response.data.total_count / ORDERS_PAGE_SIZE)) : this.state.maxPage;
    this.setState({orders, maxPage, loading: false, page});
  }

  openOrderDetails = async (orderId) => {
    const baseUrl = 'https://api.appetito.ro/';
    const token = localStorage.getItem('access_token');
    const response = await axios.default.get(`${baseUrl}v1/admin/order/${orderId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    this.setState({selectedOrder: response.data});
  }

  editInfo = async (key, value, orderId) => {
    this.setState({loading: true});
    // const baseUrl = 'http://localhost:8080/';
    const baseUrl = 'https://api.appetito.ro/';
    const token = localStorage.getItem('access_token');
    const response = await axios.default.put(`${baseUrl}v1/admin/orders/${orderId}`, {
      [key]: value
    }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    await this.getOrders(this.state.page, this.state.userId);
  }

  formatTime = (timestamp) => {
    let date = this.convertUTCDateToLocalDate(timestamp);
    let hours = date.getHours();
    let minutes = date.getMinutes();
    return hours + ':' + minutes
  };

  formatDate = (timestamp) => {
    let date = this.convertUTCDateToLocalDate(timestamp);
    return date.toLocaleDateString();
  };

  convertUTCDateToLocalDate(date) {
    const dateLocal = new Date(date);
    return dateLocal//new Date(dateLocal.getTime() - dateLocal.getTimezoneOffset() * 60 * 1000);
  }

  gotoPage = (page) => {
    if (page > this.state.maxPage) {
      page = this.state.maxPage - 1;
    }
    const canNextPage = page + 1 < this.state.maxPage;
    const canPreviousPage = page - 1 > 0;
    this.setState({canPreviousPage, canNextPage});
    this.getOrders(page, this.state.userId);
  }

  previousPage = () => {
    const canPreviousPage = this.state.page - 1 > 0;
    this.setState({canPreviousPage});
    this.getOrders(this.state.page - 1, this.state.userId);
  }

  nextPage = () => {
    const canNextPage = this.state.page + 2 < this.state.maxPage;
    this.setState({canPreviousPage: true, canNextPage});
    this.getOrders(this.state.page + 1, this.state.userId);
  }

  // "HH:MM", zero-padded — what <input type="time"> needs as its value,
  // unlike formatTime above (which is for display, e.g. "9:5").
  formatHourInput = (order) => {
    const date = order.status !== 'created' ? new Date(order.restaurant_eta) : new Date();
    return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
  }

  openFinalizeHourPicker = (event, order) => {
    this.setState({
      finalizeHourAnchor: event.currentTarget,
      finalizeHourOrder: order,
      finalizeHourValue: this.formatHourInput(order),
    });
  }

  closeFinalizeHourPicker = () => {
    this.setState({finalizeHourAnchor: null, finalizeHourOrder: null});
  }

  // Saved from the button only: on iOS Safari the time wheel fires onChange
  // as soon as the hour moves, before the minutes can be picked.
  saveFinalizeHour = () => {
    const order = this.state.finalizeHourOrder;
    const value = this.state.finalizeHourValue;
    if (!value) {
      return;
    }
    const [hours, minutes] = value.split(':').map(Number);
    const date = order.status !== 'created' ? new Date(order.restaurant_eta) : new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);
    this.editInfo("restaurant_eta", date, order.id);
    this.closeFinalizeHourPicker();
  }

  editAddress = (order) => {
    const newAddress = prompt(`Schimbă adresa pentru comanda ${order.id}`, order.address);
    if (!newAddress) {
      return;
    }
    this.editInfo("address_string", newAddress, order.id);
  }

  editPhone = (order) => {
    const newPhone = prompt(`Schimbă telefonul pentru comanda ${order.id}`, order.phone);
    if (!newPhone) {
      return;
    }
    this.editInfo("phone", newPhone, order.id);
  }

  deliveryChange = (event, order) => {
    // MenuItem values below are actual booleans (true/false), and MUI's
    // Select preserves that type on event.target.value — no string coercion
    // needed (and comparing against the string "true" was always false).
    this.editInfo("delivery", event.target.value, order.id);
  }

  statusChanged = (event, order) => {
    this.editInfo("status", event.target.value, order.id);
  }

  render() {
    const {page, maxPage, userId} = this.state;
    // 'admin' in localStorage is the super-admin flag (see OrderDetailsModal).
    const isSuperAdmin = localStorage.getItem('admin') === 'true';
    return (
      <div className={"orders-container"}>
        {isSuperAdmin && (
          <div className="orders-toolbar">
            <FormControlLabel
              control={<Switch
                color="primary"
                checked={this.state.showDeleted}
                onChange={(e) => this.setState({showDeleted: e.target.checked}, () => this.getOrders(0, this.state.userId))}/>}
              label="Toate comenzile (inclusiv șterse)"/>
            <Button variant="outlined" color="primary" onClick={() => this.setState({priceDifferencesOpen: true})}>
              Diferențe preț
            </Button>
          </div>
        )}
        {isSuperAdmin && this.state.priceDifferencesOpen && (
          <PriceDifferences
            onClose={() => {
              this.setState({priceDifferencesOpen: false});
              this.getOrders(this.state.page, this.state.userId);
            }}/>
        )}
        {!!userId && (
          <div className="orders-user-filter-banner">
            Istoric comenzi pentru clientul #{userId}
            <button className="orders-user-filter-clear" onClick={this.clearUserFilter}>
              Șterge filtrul
            </button>
          </div>
        )}
        <div className="orders-table-scroll">
        <table className="orders-table" style={{borderSpacing: 0}}>
          <thead>
          <tr className="orders-table-header-row">
            <th>Id</th>
            <th>Restaurant</th>
            <th>Data</th>
            <th>Ora</th>
            <th>Status</th>
            <th>Finalizare</th>
            <th>Livrare</th>
            <th>Plată</th>
            <th>Livrator</th>
            <th>Client</th>
            <th>Adresă</th>
            <th>Telefon</th>
          </tr>
          </thead>
          <tbody>
          {this.state.orders.map((order, i) => {
            return (
              <tr key={order.id || i} className={`${order.status}${order.deleted ? ' orders-row-deleted' : ''}`}>
                <td style={{cursor: 'pointer', textDecoration: 'underline'}}
                    onClick={() => this.openOrderDetails(order.id)}>
                  {order.id}
                  {order.deleted && <span className="orders-deleted-tag">ștearsă</span>}
                </td>
                <td>{order.restaurant}</td>
                <td>{this.formatDate(order.created)}</td>
                <td>{this.formatTime(order.created)}</td>
                <td>
                  <TextField
                    select
                    value={order.status}
                    onChange={(event) => this.statusChanged(event, order)}
                    InputProps={{className: order.status}}
                    margin="dense"
                    style={{minWidth: 120}}
                  >
                    <MenuItem value={'created'}>Creată</MenuItem>
                    <MenuItem value={'accepted'}>Acceptată</MenuItem>
                    <MenuItem value={'prepared'}>Preparată</MenuItem>
                    <MenuItem value={'picked'}>Ridicată</MenuItem>
                    <MenuItem value={'delivered'}>Livrată</MenuItem>
                    <MenuItem value={'canceled'}>Anulată</MenuItem>
                  </TextField>
                </td>
                <td>
                  <div style={{display: 'flex', alignItems: 'center'}}>
                    {order.status !== 'created' ? this.formatTime(order.restaurant_eta) : ''}
                    <IconButton size="small" title="Editează ora" onClick={(event) => this.openFinalizeHourPicker(event, order)}>
                      <EditIcon fontSize="small"/>
                    </IconButton>
                  </div>
                </td>
                <td>
                  <TextField
                    select
                    value={order.delivery}
                    onChange={(event) => this.deliveryChange(event, order)}
                    InputProps={{className: order.status}}
                    margin="dense"
                    style={{minWidth: 110}}
                  >
                    <MenuItem value={true}>Livrare</MenuItem>
                    <MenuItem value={false}>Ridicare</MenuItem>
                  </TextField>
                </td>
                <td>{order.paid ? 'Card Online' : 'Cash'}</td>
                <td>{order.deliverer}</td>
                <td>{order.user}</td>
                <td>
                  <div style={{display: 'flex', alignItems: 'center'}}>
                    {order.delivery ? order.address : 'Ridicare'}
                    {order.delivery && (
                      <IconButton size="small" title="Editează adresa" onClick={() => this.editAddress(order)}>
                        <EditIcon fontSize="small"/>
                      </IconButton>
                    )}
                  </div>
                </td>
                <td>
                  <div style={{display: 'flex', alignItems: 'center'}}>
                    {order.phone}
                    <IconButton size="small" title="Editează telefonul" onClick={() => this.editPhone(order)}>
                      <EditIcon fontSize="small"/>
                    </IconButton>
                  </div>
                </td>
              </tr>
            )
          })}
          </tbody>
        </table>
        </div>
        <div className="pagination">
          <IconButton size="small" onClick={() => this.gotoPage(0)} disabled={!this.state.canPreviousPage}>
            <FirstPageIcon fontSize="small"/>
          </IconButton>
          <IconButton size="small" onClick={() => this.previousPage()} disabled={!this.state.canPreviousPage}>
            <KeyboardArrowLeft fontSize="small"/>
          </IconButton>
          <IconButton size="small" onClick={() => this.nextPage()} disabled={!this.state.canNextPage}>
            <KeyboardArrowRight fontSize="small"/>
          </IconButton>
          <IconButton size="small" onClick={() => this.gotoPage(maxPage - 1)} disabled={!this.state.canNextPage}>
            <LastPageIcon fontSize="small"/>
          </IconButton>
          <span className="pagination-label">
            Pagina <strong>{page + 1}</strong> din {maxPage}
          </span>
          <TextField
            type="number"
            label="Mergi la pagina"
            defaultValue={page + 1}
            onChange={e => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0
              this.gotoPage(page)
            }}
            margin="dense"
            style={{width: 130}}
          />
        </div>
        {this.state.loading &&
        <div className={'loader-container'}>
          <div className={'loader'}/>
        </div>}
        <OrderDetailsModal
          order={this.state.selectedOrder}
          onClose={() => this.setState({selectedOrder: null})}
          onChanged={() => this.getOrders(this.state.page, this.state.userId)}
        />
        <Popover
          open={!!this.state.finalizeHourAnchor}
          anchorEl={this.state.finalizeHourAnchor}
          onClose={this.closeFinalizeHourPicker}
          anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
        >
          {this.state.finalizeHourOrder && (
            <div style={{padding: 16}}>
              <TextField
                type="time"
                label="Ora finalizare"
                value={this.state.finalizeHourValue}
                onChange={(event) => this.setState({finalizeHourValue: event.target.value})}
                InputLabelProps={{shrink: true}}
                inputProps={{step: 60}}
                autoFocus
              />
              <div style={{display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 12}}>
                <Button size="small" onClick={this.closeFinalizeHourPicker}>Anulează</Button>
                <Button size="small" variant="contained" color="primary" onClick={this.saveFinalizeHour}
                        disabled={!this.state.finalizeHourValue}>
                  Salvează
                </Button>
              </div>
            </div>
          )}
        </Popover>
      </div>
    )
  }
}